import React from 'react';
import Icon from '../../../component/Icon';
import Portal from '../../../component/Portal';
import './style.scss';

const goToHeadlineList = () => {
  window.location.href = '/tantu/webapp/innovation/discount-headline-list';
};

const BackToHome = () => {
  return (
    <Portal>
      <div className="back-to-home" onClick={goToHeadlineList}>
        <div>
          <Icon name="home" className="icon-home" />
        </div>
        <p>首页</p>
      </div>
    </Portal>
  );
};

export default BackToHome;
